import axios from 'axios';

const {getGenericShareableLinkUrl, deleteGenericShareableLinkUrl} = window.sn;

export async function getGenericShareableLink() {
    const response = await axios.get(getGenericShareableLinkUrl);
    return response.data.url;
}

export async function deleteGenericShareableLink() {
    const response = await axios.delete(deleteGenericShareableLinkUrl);
    return response.data.success;
}



// WEBPACK FOOTER //
// ./components/share_content_modal/share_token_api_client.js